<!-- eslint-disable vue/attribute-hyphenation -->
<template>
	<!-- <v-main v-if="!property">
		<v-overlay
			color="#ffffff"
			opacity="1"
			:value="loading"
		>
			<v-progress-circular
				color="#ccc"
				indeterminate
				size="64"
			/>
		</v-overlay>
		<div class="bgWhite">
			<v-col class="no-property d-flex align-center justify-center">
				<h1>ไม่พบข้อมูล</h1>
			</v-col>
		</div>
	</v-main> -->
	<v-main>
		<!-- <div class="d-none d-md-block">
			<v-responsive :aspect-ratio="16/9">
				<div
					class="banner"
					:style="property.bannerStyle"
				/>
			</v-responsive>
		</div> -->

		<v-overlay
			color="#ffffff"
			opacity="1"
			:value="loading"
		>
			<v-progress-circular
				color="#ccc"
				indeterminate
				size="64"
			/>
		</v-overlay>

		<v-overlay
			:value="overlay"
			z-index="6"
		>
			<v-card
				class="mx-auto"
				max-width="375"
				outlined
			>
				<v-card-text>
					<p :class="`h5 ${ alertError ? 'red' : 'teal' }--text accent-3`">
						{{ alertError ? 'พบความผิดพลาด' : 'ทำรายการสำเร็จ' }}
					</p>
					{{ alertText }}
				</v-card-text>

				<v-card-actions>
					<v-btn
						class="ml-auto"
						outlined
						text
						@click="overlayCallback"
					>
						ตกลง
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-overlay>

		<v-snackbar
			v-model="snackbar"
			color="red"
			top
			right
			:timeout="6000"
		>
			<div class="d-flex align-center">
				<div>{{ snackbarText }}</div>
				<v-btn
					density="compact"
					icon
					class="ml-auto"
					@click="snackbar = false"
				>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>
		</v-snackbar>

		<div v-if="!property && !loading">
			<v-col class="no-property d-flex align-center justify-center">
				<h1>ไม่พบข้อมูล</h1>
			</v-col>
		</div>
		<template v-if="property">
			<div
				ref="topPage"
				class="head-banner"
			>
				<div class="py-6">
					<v-container class="pa-0">
						<v-row no-gutters>
							<v-col
								xl="8"
								class="mx-auto px-5 px-sm-10"
							>
								<div style="position: relative;">
									<div
										class="d-flex align-start"
										style="white-space: nowrap;"
									>
										<v-btn
											color="#000"
											elevation="0"
											class="mt-n1"
											fab
											x-small
											dark
											:to="{ name: 'index' }"
										>
											<v-icon>mdi-home</v-icon>
										</v-btn>

										<div
											class="d-flex align-start overflow-x-hidden"
											style="margin-right: 75px;"
										>
											<template
												v-for="(item, i) in property.breadcrumb"
											>
												<template v-if="i > 0 && i < property.breadcrumb.length - 1">
													<v-divider
														:key="`dv-${i}`"
														class="mx-2 mt-3"
														style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
													/>
													<v-btn
														:key="`bc-${i}`"
														color="red"
														class="px-0"
														height="auto"
														exact
														x-large
														text
														:to="item.to || null"
													>
														{{ item.text }}
													</v-btn>
												</template>
											</template>
										</div>

										<div
											class="contactBtn shareMenu ml-auto"
											style="white-space: nowrap;"
										>
											<v-menu
												:close-on-content-click="false"
												:nudge-width="400"
												max-width="400"
												bottom
												left
												offset-y
											>
												<template v-slot:activator="{ on }">
													<v-btn
														v-on="on"
													>
														<v-icon>mdi-share</v-icon>
													</v-btn>
												</template>

												<v-card class="px-4 py-7">
													<h4>แชร์เลย</h4>
													<v-row>
														<v-col cols="6">
															<v-btn
																width="100%"
																color="indigo lighten-1 white--text"
															>
																<v-icon class="mr-1">
																	mdi-facebook-messenger
																</v-icon> Messenger
															</v-btn>
														</v-col>
														<v-col cols="6">
															<mail
																width="100%"
																color="yellow darken-3 white--text"
																mail=" "
																:title="`แชร์ ${property.property_title} ให้ทางเมลล์`"
																:url="`https://url.tb.co.th/${isPresentationMode ? 'presentation' : 'p'}/${property.id}`"
															>
																<v-icon class="mr-1">
																	mdi-email-outline
																</v-icon> อีเมล
															</mail>
														</v-col>
														<v-col cols="6">
															<facebook-share
																width="100%"
																color="indigo darken-2 white--text"
																:url="`https://url.tb.co.th/${isPresentationMode ? 'presentation' : 'p'}/${property.id}`"
															>
																<v-icon class="mr-1">
																	mdi-facebook
																</v-icon> Facebook
															</facebook-share>
														</v-col>
														<v-col cols="6">
															<line-share
																width="100%"
																color="light-green darken-1 white--text"
																:url="`https://url.tb.co.th/${isPresentationMode ? 'presentation' : 'p'}/${property.id}`"
															>
																<v-icon class="mr-1">
																	mdi-chat-outline
																</v-icon> Line
															</line-share>
														</v-col>
														<v-col cols="6">
															<!-- <twitter-share
																width="100%"
																color="light-blue accent-1 white--text"
															>
																<v-icon class="mr-1">
																	mdi-twitter
																</v-icon> Twitter
															</twitter-share> -->
															<v-btn
																v-if="!isPresentationMode"
																:to="$route.path.replace('/property/', '/property-presentation/')"
																color="light-blue accent-1 white--text"
																title="ดูในรูปแบบนำเสนอ"
																width="100%"
															>
																<slot>
																	<v-icon class="mr-1">
																		mdi-presentation
																	</v-icon>
																	นำเสนอ
																</slot>
															</v-btn>
															<!-- <v-btn
																v-else
																:to="$route.path.replace('/property-presentation/', '/property/')"
																color="light-blue accent-1 white--text"
																title="ดูข้อมูลแบบเต็ม"
																width="100%"
															>
																<slot>
																	<v-icon class="mr-1">
																		mdi-origin
																	</v-icon>
																	มูลแบบเต็ม
																</slot>
															</v-btn> -->
														</v-col>
														<!-- <v-col cols="6">
															<v-btn
																width="100%"
																color="grey darken-2 white--text"
															>
																<v-icon class="mr-1">
																	mdi-chat
																</v-icon> SMS
															</v-btn>
														</v-col> -->
														<v-col cols="6">
															<v-btn
																width="100%"
																color="grey darken-3 white--text"
																@click="presentationUrlCopy($refs.propertyUrl)"
															>
																<v-icon class="mr-1">
																	mdi-link-variant
																</v-icon> คัดลอกลิงค์
															</v-btn>
															<input
																ref="propertyUrl"
																type="text"
																class="d-none"
																style="border: none !important;"
															>
														</v-col>
														<v-col cols="6">
															<v-btn
																color="red"
																title="share location ของทรัพย์นี้"
																width="100%"
																style="text-transform: capitalize;"
																target="_blank"
																:href="`http://maps.google.com/maps?q=${propLocationString}`"
																dark
																:on-click="`fbq('track', 'Navigator.Property.${property.id}');`"
															>
																<v-icon>mdi-map-marker</v-icon> แชร์ location
															</v-btn>
														</v-col>
													</v-row>
												</v-card>
											</v-menu>
											<a
												v-if="!isPresentationMode"
												v-ripple
												@click="addOrRemoveFavorite(property.id)"
											>
												<v-icon>mdi-heart{{ isFavorite(property.id) ? '' : '-outline' }}</v-icon>
											</a>
										</div>
									</div>
								</div>
							</v-col>
						</v-row>
					</v-container>
				</div>
			</div>

			<div>
				<div id="carousel">
					<img
						v-for="(img, index) in property.arrayImage"
						:key="index"
						:src="imageURL(img)"
						draggable="false"
						@click="openGallery(index)"
					>
				</div>
				<div
					id="gallery"
					ref="gallery"
				>
					<gallery :image="imageSelected">
						<img
							v-for="(item, index) in property.arrayImage"
							:id="`gallery-${index}`"
							:key="index"
							:ref="`gallery-${index}`"
							:src="imageURL(item)"
						>
					</gallery>
				</div>
			</div>

			<div>
				<v-container class="py-0">
					<v-row>
						<v-col
							xl="8"
							offset-xl="2"
							class="pa-0"
						>
							<v-row no-gutters>
								<v-col
									cols="12"
									md="9"
									style="padding: 10px 20px 10px 12px;"
								>
									<span class="red--text font-weight-black">รหัสทรัพย์ T-{{ property.id }}</span>
									<h1 style="line-height: 1em;">
										{{ property.property_title }}
									</h1>
									<div class="mt-4 d-flex mini-detail">
										<div>
											<img src="/images/2.0/icon/property-card/ic_area.png">
											{{ `${property.space_1 || 0}-${property.space_2 || 0}-${property.space_3 || 0}` }}
										</div>
										<div>
											<img src="/images/2.0/icon/property-card/ic_area-use.png">
											{{ property.area || '-' }}
										</div>
										<div>
											<img src="/images/2.0/icon/property-card/ic_layers.png">
											{{ property.high_floor || '-' }}
										</div>
										<div>
											<img src="/images/2.0/icon/property-card/ic_sofa.png">
											{{ property.bedroom || '-' }}
										</div>
										<div>
											<img src="/images/2.0/icon/property-card/ic_shower.png">
											{{ property.bathroom || '-' }}
										</div>
										<div>
											<img src="/images/2.0/icon/property-card/ic_car.png">
											{{ property.car_park || '-' }}
										</div>
									</div>
								</v-col>
								<v-col
									cols="12"
									md="3"
								>
									<div class="dividerGray d-md-none" />
									<v-row
										no-gutters
										class="text-center text-md-left"
									>
										<v-col
											cols="6"
											md="12"
											class="property-price pl-md-6 py-3"
										>
											<div class="d-inline-block text-left mt-n2">
												<template v-if="property.sale_price !== '0.00'">
													<span>ราคา(บาท)</span>
													<div>
														{{ numberFormat(property.sale_price) }}
													</div>
												</template>
												<template v-else-if="property.rental_price !== '0.00'">
													<span>เช่า(บาท/เดือน)</span>
													<div>
														{{ numberFormat(property.rental_price) }}
													</div>
												</template>
												<template v-else>
													<span>ราคา(บาท)</span>
													<div>N/A</div>
												</template>
											</div>
										</v-col>
										<v-col
											cols="6"
											md="12"
											class="pl-md-5 pb-3 pt-5 pt-md-3"
										>
											<div class="d-inline-block text-left">
												<div class="d-flex align-center">
													<v-icon
														class="mr-1"
														color="rgb(237,28,36)"
													>
														mdi-clock
													</v-icon>
													ประกาศ
												</div>
												<div class="pl-7">
													{{ timeAgo(property.updated_at) }}
												</div>
											</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</div>

			<div class="dividerGray" />
			<div>
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
						>
							<div
								no-gutters
								class="tabMenu d-flex pl-md-3"
							>
								<!-- eslint-disable -->
								<!-- <v-col> -->
								<v-btn
									class="active px-6 py-3 py-md-4 flex-grow-1 flex-md-grow-0"
									style="box-sizing: content-box;"
									color="red darken-4"
									height="auto"
									elevation="0"
									tile
									:onClick="`fbq('track', 'Information.Property.${property.id}'); _lt('send', 'Information.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
								>
									<div class="d-md-flex text-center">
										<v-icon>
											mdi-file-document
										</v-icon>
										<div>รายละเอียด</div>
									</div>
								</v-btn>
								<v-btn
									v-if="coordinateValid"
									class="px-6 py-3 py-md-4 flex-grow-1 flex-md-grow-0"
									style="box-sizing: content-box;"
									to="#location"
									height="auto"
									elevation="0"
									tile
									@click="$refs.location.scrollIntoView({ behavior: 'smooth', block: 'center' })"
									:onClick="`fbq('track', 'Location.Property.${property.id}'); _lt('send', 'Location.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
								>
									<div class="d-md-flex text-center">
										<v-icon>
											mdi-map-marker
										</v-icon>
										<div>ทำเลที่ตั้ง</div>
									</div>
								</v-btn>
								<v-btn
									v-if="property.sale_price !== '0.00'"
									class="px-6 py-3 py-md-4 flex-grow-1 flex-md-grow-0"
									style="box-sizing: content-box;"
									to="#calculator"
									height="auto"
									elevation="0"
									tile
									@click="$refs.calculator.scrollIntoView({ behavior: 'smooth', block: 'center' })"
									:onClick="`fbq('track', 'Calculate.Property.${property.id}'); _lt('send', 'Calculate.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
								>
									<div class="d-md-flex text-center">
										<v-icon>mdi-calculator</v-icon>
										<div>คำนวนสินเชื่อ</div>
									</div>
								</v-btn>
								<!-- </v-col> -->
								<!-- eslint-enable -->
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div class="dividerGray" />

			<div>
				<v-container class="pt-8">
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
						>
							<v-row no-gutters>
								<v-col
									cols="12"
									md="11"
									style="padding: 10px 20px 10px 12px;"
								>
									<div class="d-flex">
										<v-icon
											color="#000"
											large
										>
											mdi-home
										</v-icon>
										<h2 class="red--text ml-3">
											ข้อมูลอสังหาริมทรัพย์
										</h2>
									</div>

									<div class="content-box mt-3">
										<div class="py-3 d-md-flex align-center justify-center text-center">
											รหัสประกาศ
											<div class="red--text font-weight-black title ml-md-2">
												{{ property.id }}
											</div>
										</div>

										<v-row class="property-spec justify-center bgWhite px-3">
											<v-col
												cols="6"
												md="2"
											>
												<span>ประเภท</span>
												<div class="red--text">
													{{ property.category }}
												</div>
											</v-col>
											<v-col
												cols="6"
												md="2"
												class="pl-6"
											>
												<span class="dot">จำนวนชั้น</span>
												<div>{{ property.high_floor ? property.high_floor : '-' }}</div>
											</v-col>
											<v-col
												cols="6"
												md="2"
												class="pl-6"
											>
												<span class="dot">ห้องนอน</span>
												<div>{{ property.bedroom ? property.bedroom : '-' }}</div>
											</v-col>
											<v-col
												cols="6"
												md="2"
												class="pl-6"
											>
												<span class="dot">ห้องน้ำ</span>
												<div>{{ property.bathroom ? property.bathroom : '-' }}</div>
											</v-col>
											<v-col
												cols="6"
												md="2"
												class="pl-6"
											>
												<span class="dot">ห้องอยู่ชั้นที่</span>
												<div>{{ property.at_floor ? property.at_floor : '-' }}</div>
											</v-col>
											<v-col
												cols="6"
												md="2"
												class="pl-6"
											>
												<span class="dot">ที่จอดรถ</span>
												<div>{{ property.car_park ? property.car_park : '-' }}</div>
											</v-col>
											<v-col
												cols="6"
												md="2"
												class="pl-6"
											>
												<span class="dot">เนื้อที่(ตร.ว.)</span>
												<div>{{ property.spaceTotal === '-' ? '-' : numberFormat(property.spaceTotal) }}</div>
											</v-col>
											<v-col
												cols="6"
												md="2"
												class="pl-6"
											>
												<span class="dot">พื้นที่ใช้สอย(ตร.ม.)</span>
												<div>{{ property.area ? property.area : '-' }}</div>
											</v-col>
											<v-col
												cols="6"
												md="2"
												class="pl-6"
											>
												<span class="dot">อายุทรัพย์(ปี)</span>
												<div>{{ property.property_age ? property.property_age : '0' }}</div>
											</v-col>
											<v-col
												cols="6"
												md="2"
												class="pl-6"
											>
												<span class="dot">หันหน้าทางทิศ</span>
												<div>{{ propertyDirectionText(property.property_direction) }}</div>
											</v-col>
										</v-row>
									</div>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</div>

			<div>
				<v-container class="pt-8">
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
						>
							<v-row no-gutters>
								<v-col
									cols="12"
									md="11"
									style="padding: 10px 20px 10px 12px;"
								>
									<div class="d-flex align-end">
										<v-icon
											color="#000"
											large
										>
											mdi-file-document
										</v-icon>
										<h2 class="red--text ml-3">
											รายละเอียด
										</h2>
										<v-btn
											color="rgb(237,28,36)"
											class="ml-auto d-md-none"
											dark
											small
											@click="$refs.propertyDetailText.value += $refs.propertyDetail.innerText?.replace('อ่านเพิ่มเติม', ''); copyText($refs.propertyDetailText)"
										>
											คัดลอก
										</v-btn>
										<textarea
											ref="propertyDetailText"
											class="d-none"
											style="border: none !important;"
											:value="property.property_title + '\n'"
										/>
									</div>

									<div
										ref="propertyDetail"
										class="content-box expandable mt-3 pa-5"
										:class="{'expanded': descriptionExpanded}"
									>
										<div
											class="expand-btn d-flex align-center px-5 pt-10 pb-6 red--text"
											@click="descriptionExpanded = true"
										>
											อ่านเพิ่มเติม
											<v-icon class="red--text ml-2">
												mdi-chevron-down
											</v-icon>
										</div>

										<template v-if="property.project">
											โครงการ : {{ property.project }}
											<br>
										</template>
										<template v-else-if="property.tag_project && property.tag_project.name">
											โครงการ : {{ property.tag_project.name }}
											<br>
										</template>
										ที่ตั้ง :
										{{ property.address_alley_enter ? `ซ. ${property.address_alley_enter}` : '' }}
										{{ property.address_road ? ` ถนน ${property.address_road}` : '' }}
										{{ property.locationText }}
										<br>
										{{ `รหัสทรัพย์ : T-${property.id}` }}
										<br><br>
										{{ `ประเภท : ${property.category}` }}<br>
										<template v-if="property.high_floor && !['ที่ดิน'].includes(property.category)">
											{{ `สูง : ${property.high_floor} ชั้น` }}
											<br>
										</template>
										<template v-if="property.building_name && property.category === 'คอนโดมิเนียม'">
											{{ `อาคาร : ${property.building_name}` }}
											<br>
										</template>
										<template v-if="property.at_floor && ['คอนโดมิเนียม', 'เอื้ออาทร'].includes(property.category)">
											{{ `ห้องอยู่ชั้นที่ : ${property.at_floor}` }}
											<br>
										</template>
										<template v-if="!['คอนโดมิเนียม', 'เอื้ออาทร'].includes(property.category) && (property.space_1 || property.space_2 || property.space_3)">
											เนื้อที่ :
											{{ property.space_1 ? ` ${property.space_1} ไร่ ` : '' }}
											{{ property.space_2 ? ` ${property.space_2} งาน ` : '' }}
											{{ property.space_3 ? ` ${property.space_3} ตารางวา ` : '' }}
											<br>
										</template>
										<template v-if="property.area">
											{{ `พื้นที่ใช้สอย : ${numberFormat(property.area)} ตารางเมตร` }}
											<br>
										</template>
										<template v-if="property.area_width">
											{{ `กว้าง : ${numberFormat(property.area_width)} เมตร` }}
											<br>
										</template>
										<template v-if="property.area_deep">
											{{ `ลึก : ${numberFormat(property.area_deep)} เมตร` }}
											<br>
										</template>
										<template v-if="property.bedroom">
											{{ `ห้องนอน : ${property.bedroom} ห้อง` }}
											<br>
										</template>
										<template v-if="property.bathroom">
											{{ `ห้องน้ำ : ${property.bathroom} ห้อง` }}
											<br>
										</template>
										<template v-if="property.other_room">
											{{ `ห้องอื่นๆ : ${property.other_room}` }}
											<br>
										</template>
										<template v-if="property.car_park">
											{{ `จอดรถได้ : ${property.car_park} คัน` }}
											<br>
										</template>
										<template v-if="property.property_direction">
											{{ `ทิศ : ${propertyDirectionText(property.property_direction)}` }}
											<br>
										</template>
										<template v-if="property.explanation">
											<br>
											รายละเอียดเพิ่มเติม : <br>
											<template v-if="property.explanation">
												<pre style="font-family: inherit; white-space: pre-wrap;">{{ property.explanation }}</pre>
												<br>
											</template>
										</template>
										<template v-if="property.facility_text">
											{{ `สิ่งอำนวยความสะดวก : ${property.facility_text}` }}
											<br>
										</template>
										<br>
										<template v-if="property.type_action === 'ขาย'">
											<br>
											{{ `ราคา : ${numberFormat(property.sale_price)} บาท` }}
											<br>
										</template>
										<template v-else-if="property.type_action === 'เช่า'">
											<br>
											{{ `เช่า : ${numberFormat(property.rental_price)} บาท / เดือน` }}
											<br>
										</template>
										<template v-else>
											<br>
											{{ `ราคา : ${numberFormat(property.sale_price)} บาท` }}<br>
											{{ `เช่า : ${numberFormat(property.rental_price)} บาท / เดือน` }}
											<br>
										</template>
										<template v-if="!property.website_hide_link_google_map && propLocationString">
											<br>
											ลิงค์แผนที่ :
											<a
												:href="`https://maps.google.com/?q=${propLocationString}`"
												target="_blank"
											>
												https://maps.google.com/?q={{ propLocationString }}
											</a>
										</template>
										<template v-if="!isPresentationMode">
											<br>
											<br>**เรามีบริการจัดสินเชื่อให้ฟรี พร้อมยินดีให้คำปรึกษา มีให้เลือกทุกธนาคาร**
											<br>**พร้อมอัตราดอกเบี้ยพิเศษ และ วงเงินสูงสุด 90-100% ของราคาประเมิน**
											<br><br>สนใจสอบถามข้อมูลเพิ่มเติม หรือ นัดชมบ้านได้ที่
											<br>
											<template v-if="agent && typeof agent !== 'undefined' && (!agent.website_display_type || ['default', 'main'].includes(agent.website_display_type))">
												Tel : {{ agent.phone }} {{ agent.nick_name }} (รหัสตัวแทน {{ agent.id }})
												<template v-if="agent.line">
													<br> Line ID : {{ agent.line }}
												</template>
												<br>
											</template>
											<template v-if="agent && agent.name_first_joint && agent.phone_joint && (!agent.website_display_type || ['default', 'joint'].includes(agent.website_display_type))">
												<br>
												Tel : {{ agent.phone_joint }} {{ agent.nick_name_joint }} (รหัสตัวแทน {{ agent.id }}-1)
												<template v-if="agent.line_joint">
													<br> Line ID : {{ agent.line_joint }}
												</template>
												<br>
											</template>
											<!-- <template v-if="refer && refer.id != 1000">
												<br>
												ผู้ดูแลสำรอง
												<template v-if="refer.phone">
													<br> Tel : {{ refer.phone }} {{ refer.nick_name }} (รหัสตัวแทน {{ refer.id }})
												</template>
												<template v-if="refer.line">
													<br> Line ID : {{ refer.line }}
												</template>
												<br>
											</template> -->
											<br><br>Callcenter : 02-047-4282
											<br><br>สนใจดูทรัพย์อื่นๆ เพิ่มเติม มากกว่า 3,000 รายการ
											<br>
											<v-btn
												to="/"
												text
											>
												www.tb.co.th
											</v-btn>
										</template>
										<template v-else>
											<br>
											<br>โปรดติดต่อตัวแทนผู้ที่ส่งลิงค์เว็บไซต์นี้ให้คุณ เนื่องจากลิงค์เว็บไซต์นี้ใช้สำหรับนำเสนอข้อมูลเท่านั้น
										</template>
										<br><br>The Best Property Agent CO,.LTD. ผู้นำด้านธุรกิจนายหน้า ตัวแทนอสังหาริมทรัพย์ครบวงจร ด้วยความเป็นมืออาชีพ ใช้เทคโนโลยี และ นวัตกรรมที่สร้างสรรค์  เพื่อส่งมอบบริการที่ดีที่สุดเพื่อคุณ ให้บริการด้าน ซื้อ ขาย เช่า อสังหาริมทรัพย์
									</div>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</div>

			<div>
				<v-container class="pt-8">
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
						>
							<v-row no-gutters>
								<v-col
									ref="location"
									cols="12"
									md="11"
									style="padding: 10px 20px 10px 12px;"
								>
									<div class="d-flex">
										<v-icon
											color="#000"
											large
										>
											mdi-map-marker
										</v-icon>
										<h2 class="red--text ml-3">
											ทำเลที่ตั้ง
										</h2>
									</div>

									<div
										class="content-box mt-3"
									>
										<client-only>
											<mapDetail
												:expand="focusMap"
												:property="property"
											/>
										</client-only>
									</div>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</div>

			<div v-if="property.sale_price !== '0.00' && !property.hide_installments">
				<v-container class="pt-8">
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
						>
							<v-row no-gutters>
								<v-col
									ref="calculator"
									cols="12"
									md="11"
									style="padding: 10px 20px 10px 12px;"
								>
									<div class="d-flex">
										<v-icon
											color="#000"
											large
										>
											mdi-calculator
										</v-icon>
										<h2 class="red--text ml-3">
											คำนวนสินเชื่อ
										</h2>
									</div>

									<div
										class="content-box mt-3"
									>
										<v-row>
											<v-col
												cols="12"
												md="8"
												class="bgWhite installment-config px-6 pb-0"
											>
												<v-row class="align-center">
													<v-col
														cols="3"
														class="flex-shrink-1"
													>
														ราคาทรัพย์
													</v-col>
													<v-col
														cols="9"
														class="full-price text-right flex-grow-1"
													>
														{{ numberFormat(price) }}
													</v-col>
													<v-col cols="6">
														<div class="d-flex">
															<div class="down">
																เงินดาวน์<i />
															</div>
															<div class="ml-auto">
																<span class="red--text">
																	[ {{ downPayment }}% ]
																</span>
															</div>
														</div>
														<v-text-field
															:value="numberFormat(price * downPayment / 100)"
															type="text"
															hide-details
															dense
															outlined
															disabled
															class="fieldDisabled"
														/>
													</v-col>
													<v-col cols="6">
														<div class="d-flex">
															<div class="amount">
																เงินกู้<i />
															</div>
															<div class="ml-auto">
																<span class="red--text">
																	[ {{ 100 - downPayment }}% ]
																</span>
															</div>
														</div>
														<v-text-field
															:value="numberFormat(price * (100 - downPayment) / 100)"
															type="text"
															hide-details
															dense
															outlined
															disabled
															class="fieldDisabled"
														/>
													</v-col>
													<v-col cols="12 py-0">
														<v-slider
															v-model="downPayment"
															track-color="#adadad"
															thumb-color="#c20000"
															thumb-size="100"
															track-fill-color="#c20000"
															height="10"
														/>
													</v-col>
													<v-col
														cols="12"
														md="6"
														class="pb-0"
													>
														<div>
															อัตราดอกเบี้ย (%)
														</div>
														<v-text-field
															v-model="interestRate"
															min="0"
															max="15"
															type="number"
															dense
															outlined
															hide-details
														/>
														<v-slider
															v-model="interestRate"
															track-color="#adadad"
															thumb-color="#c20000"
															thumb-size="100"
															track-fill-color="#c20000"
															min="0"
															max="15"
															step="0.01"
															hide-details
														/>
													</v-col>
													<v-col
														cols="12"
														md="6"
														class="pb-0"
													>
														<div>
															ระยะเวลาผ่อน (ปี)
														</div>
														<v-text-field
															v-model="duration"
															min="0"
															max="15"
															type="number"
															dense
															outlined
															hide-details
														/>
														<v-slider
															v-model="duration"
															track-color="#adadad"
															thumb-color="#c20000"
															thumb-size="100"
															track-fill-color="#c20000"
															min="3"
															max="40"
															hide-details
														/>
													</v-col>
												</v-row>
											</v-col>
											<v-col
												cols="12"
												md="4"
												class="progress text-center"
											>
												<v-progress-circular
													:value="downPayment"
													size="220"
													width="50"
													color="#c20000"
													class="mt-2"
													:rotate="270"
												/>
												<div class="installment text-center">
													<b>ยอดชำระ</b>
													<div>
														{{ downPayment === 100 ? 0 : numberFormat(parseInt((((interestRate/1200) * (price * (100 - downPayment) / 100)) / (1 - (Math.pow(1 / (1 + (interestRate/1200)), 12 * duration))) / 100) + 1) * 100) }}
													</div>
													<b>บ./เดือน</b>
												</div>
												<div class="d-flex justify-center mt-5">
													<div class="down">
														<span />เงินดาวน์
													</div>
													<div class="amount ml-3">
														<span />เงินกู้
													</div>
												</div>
											</v-col>
										</v-row>
									</div>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</div>

			<div
				v-if="agent && typeof agent !== 'undefined' && !isPresentationMode"
				class="agent-widget d-none d-md-block"
			>
				<v-container>
					<v-row no-gutters>
						<v-col
							xl="9"
							class="mx-auto"
						>
							<div class="agent d-flex">
								<div class="agent-contact d-flex px-8 py-4">
									<n-link
										:to="$routerHelper.getPathByRouteName('agent-detail', { id: agent.id })"
										:onClick="`fbq('track', 'Agent.Property.${property.id}'); _lt('send', 'Agent.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
									>
										<z-img
											:storage="agent.avatar_url || `https://api.tb.co.th/api/getImageAgent?id=${agent.avatar}`"
											width="160"
											class="image-agent"
										/>
									</n-link>
									<div class="d-flex flex-column justify-center align-center ml-4">
										<template v-if="!agent.website_display_type || ['default', 'main'].includes(agent.website_display_type)">
											<n-link
												:to="$routerHelper.getPathByRouteName('agent-detail', { id: agent.id })"
												:onClick="`fbq('track', 'Agent.Property.${property.id}'); _lt('send', 'Agent.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
											>
												{{ agent.name }} {{ agent.surname }} ({{ agent.nick_name }})
											</n-link>
											<div class="d-flex flex-nowrap mt-1 mb-2">
												<v-btn
													class="call"
													color="red darken-4"
													width="90"
													:disabled="agent.phone ? false : true"
													:href="`tel:${agent.phone}`"
													taget="_blank"
													:onClick="`fbq('track', 'Call.Property.${property.id}'); _lt('send', 'Call.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
												>
													<v-icon>mdi-phone</v-icon>
												</v-btn>
												<v-btn
													class="line ml-1"
													color="#00c300"
													width="90"
													:disabled="agent.line ? false : true"
													:href="`https://line.me/ti/p/~${agent.line}`"
													taget="_blank"
													:onClick="`fbq('track', 'Line.Property.${property.id}'); _lt('send', 'Line.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
												>
													<img
														src="/images/2.0/icon/line.png"
														width="24"
													>
												</v-btn>
											</div>
										</template>

										<template v-if="agent && agent.is_joint && agent.name_first_joint && agent.phone_joint && (!agent.website_display_type || ['default', 'joint'].includes(agent.website_display_type))">
											<n-link
												:to="$routerHelper.getPathByRouteName('agent-detail', { id: agent.id })"
												:onClick="`fbq('track', 'Agent.Property.${property.id}'); _lt('send', 'Agent.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
											>
												{{ agent.name_first_joint }} {{ agent.name_last_joint }} ({{ agent.nick_name_joint }})
											</n-link>
											<div class="d-flex flex-nowrap mt-1">
												<v-btn
													class="call"
													color="red darken-4"
													width="90"
													:disabled="agent.phone_joint ? false : true"
													:href="`tel:${agent.phone_joint}`"
													taget="_blank"
													:onClick="`fbq('track', 'Call.Property.${property.id}'); _lt('send', 'Call.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
												>
													<v-icon>mdi-phone</v-icon>
												</v-btn>
												<v-btn
													class="line ml-1"
													color="#00c300"
													width="90"
													:disabled="agent.line_joint ? false : true"
													:href="`https://line.me/ti/p/~${agent.line_joint}`"
													taget="_blank"
													:onClick="`fbq('track', 'Line.Property.${property.id}'); _lt('send', 'Line.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
												>
													<img
														src="/images/2.0/icon/line.png"
														width="24"
													>
												</v-btn>
											</div>
										</template>
									</div>
								</div>

								<div class="divider-v d-flex align-center">
									<div>หรือ</div>
								</div>

								<v-form
									ref="contactForm"
									v-model="contactForm"
									class="contact-form"
									lazy-validation
								>
									<div class="callback d-flex align-center px-8 py-4">
										<v-row>
											<v-col
												cols="12"
												class="py-0"
											>
												<b>ให้เราติดต่อกลับเพื่อดูแลคุณ</b>
											</v-col>
											<v-col
												cols="6"
												class="py-1"
											>
												<v-text-field
													v-model="customerName"
													placeholder="ชื่อ-นามสกุล *"
													:rules="[ v => !!v || 'จำเป็นต้องกรอกชื่อ' ]"
													required
													dense
													outlined
												/>
											</v-col>
											<v-col
												cols="6"
												class="py-1"
											>
												<v-text-field
													v-model="customerPhone"
													placeholder="เบอรโทรติดต่อ *"
													maxlength="10"
													:rules="[ v => !!v || 'จำเป็นต้องระบุหมายเลขโทรศัพท์', v => (v && /[\d]{10}/.test(v)) || 'เบอร์โทรศัพท์ไม่ถูกต้อง' ]"
													required
													dense
													outlined
												/>
											</v-col>
											<v-col
												cols="12"
												class="py-1"
											>
												<v-textarea
													v-model="additionalDetail"
													placeholder="ฝากข้อความถึงเรา"
													rows="2"
													no-resize
													dense
													outlined
													hide-details
												/>
											</v-col>
										</v-row>
										<v-btn
											color="#c20000"
											class="ml-5"
											:loading="submitLoading"
											:disabled="submitLoading"
											tile
											@click="submitQuery"
										>
											<v-icon color="#fff">
												mdi-send
											</v-icon>
										</v-btn>
									</div>
								</v-form>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>

			<div
				v-if="agent && typeof agent !== 'undefined' && !isPresentationMode"
				class="agent-widget mobile d-md-none"
			>
				<v-expansion-panels>
					<v-expansion-panel>
						<v-expansion-panel-header color="#c20000">
							<div
								class="py-1 text-center white--text"
								style="font-size: 1.4rem;"
							>
								ติดต่อตัวแทนขาย
							</div>
							<template v-slot:actions>
								<v-icon color="#fff">
									mdi-chevron-down
								</v-icon>
							</template>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<div class="agent-contact text-center py-6">
								<n-link
									class="d-inline-block"
									:to="$routerHelper.getPathByRouteName('agent-detail', { id: agent.id })"
									:onClick="`fbq('track', 'Agent.Property.${property.id}'); _lt('send', 'Agent.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
								>
									<z-img
										:storage="agent.avatar_url || `https://api.tb.co.th/api/getImageAgent?id=${agent.avatar}`"
										width="160"
										class="image-agent"
									/>
								</n-link>
								<div class="d-flex flex-column align-center">
									<template v-if="!agent.website_display_type || ['default', 'main'].includes(agent.website_display_type)">
										<n-link
											:to="$routerHelper.getPathByRouteName('agent-detail', { id: agent.id })"
											:onClick="`fbq('track', 'Agent.Property.${property.id}'); _lt('send', 'Agent.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
										>
											{{ agent.name }} {{ agent.surname }} ({{ agent.nick_name }})
										</n-link>
										<div class="d-flex flex-nowrap mt-1 mb-2">
											<v-btn
												class="call"
												color="red darken-4"
												width="90"
												:disabled="agent.phone ? false : true"
												:href="`tel:${agent.phone}`"
												taget="_blank"
												:onClick="`fbq('track', 'Call.Property.${property.id}'); _lt('send', 'Call.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
											>
												<v-icon>mdi-phone</v-icon>
											</v-btn>
											<v-btn
												class="line ml-1"
												color="#00c300"
												width="90"
												:disabled="agent.line ? false : true"
												:href="`https://line.me/ti/p/~${agent.line}`"
												taget="_blank"
												:onClick="`fbq('track', 'Line.Property.${property.id}'); _lt('send', 'Line.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
											>
												<img
													src="/images/2.0/icon/line.png"
													width="24"
												>
											</v-btn>
										</div>
									</template>

									<template v-if="agent && agent.name_first_joint && agent.phone_joint && (!agent.website_display_type || ['default', 'joint'].includes(agent.website_display_type))">
										<n-link
											:to="$routerHelper.getPathByRouteName('agent-detail', { id: agent.id })"
											:onClick="`fbq('track', 'Agent.Property.${property.id}'); _lt('send', 'Agent.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
										>
											{{ agent.name_first_joint }} {{ agent.name_last_joint }} ({{ agent.nick_name_joint }})
										</n-link>
										<div class="d-flex flex-nowrap mt-1">
											<v-btn
												class="call"
												color="red darken-4"
												width="90"
												:disabled="agent.phone_joint ? false : true"
												:href="`tel:${agent.phone_joint}`"
												taget="_blank"
												:onClick="`fbq('track', 'Call.Property.${property.id}'); _lt('send', 'Call.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
											>
												<v-icon>mdi-phone</v-icon>
											</v-btn>
											<v-btn
												class="line ml-1"
												color="#00c300"
												width="90"
												:disabled="agent.line_joint ? false : true"
												:href="`https://line.me/ti/p/~${agent.line_joint}`"
												taget="_blank"
												:onClick="`fbq('track', 'Line.Property.${property.id}'); _lt('send', 'Line.Property.${property.id}', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
											>
												<img
													src="/images/2.0/icon/line.png"
													width="24"
												>
											</v-btn>
										</div>
									</template>
								</div>
							</div>

							<div class="divider-h d-flex justify-center">
								<div>หรือ</div>
							</div>

							<div class="py-10 px-12 text-center">
								<b>ให้เราติดต่อกลับเพื่อดูแลคุณ</b>
								<v-text-field
									class="my-2"
									placeholder="ชื่อ-นามสกุล"
									dense
									outlined
									hide-details
								/>
								<v-text-field
									class="my-2"
									placeholder="เบอรโทรติดต่อ"
									type="number"
									dense
									outlined
									hide-details
								/>
								<v-textarea
									class="my-2"
									placeholder="ฝากข้อความถึงเรา"
									rows="2"
									no-resize
									dense
									outlined
									hide-details
								/>
								<v-btn
									color="#c20000"
									block
									tile
								>
									<v-icon color="#fff">
										mdi-send
									</v-icon>
								</v-btn>
							</div>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</div>
		</template>
	</v-main>
</template>

<script>

const doc = 'details'

const configSearch = require('../../plugins/config-search')

import { mapActions, mapGetters } from 'vuex'
import mapDetail from '~/components/2.0/map-detail'
import gallery from '~/components/helpers/gallery.vue'

export default {
	name: 'DETAIL',
	layout: 'default_2',
	scrollToTop: true,

	components: {
		mapDetail,
		gallery
	},

	async fetch(context) {
		let id = isNaN(context.params.id) ? context.params.id : parseInt(context.params.id)
		let property = await context.store.dispatch('property/setProperty', id)

		if (property) {
			await context.store.dispatch('page/initial', {
				doc: doc,
				description: `${property.address_alley_enter ? `ซ. ${property.address_alley_enter}` : ''}${property.address_road ? ` ถนน ${property.address_road}` : ''} ${property.sale_price ? `เสนอขายในราคา : ${property.sale_price} บาท` : ''} ${`รหัสทรัพย์ : T-${property.id}`}${property.category}${property.high_floor ? ` ${property.high_floor} ชั้น` : ''} ${property.space_1 ? ` ${property.space_1} ไร่` : ''}${property.space_2 ? ` ${property.space_2} งาน` : ''}${property.space_3 ? ` ${property.space_3} ตารางวา` : ''}${property.area ? ` พื้นที่ใช้สอยประมาณ ${property.area} ตารางเมตร` : ''}${property.car_park ? ` จอดรถได้ ${property.area} คัน` : ''}${property.bedroom || property.bathroom ? ` ตัวบ้านมี ${property.bedroom ? ` ${property.bedroom} ห้องนอน ` : ''} ${property.bathroom ? ` ${property.bathroom} ห้องน้ำ ` : ''} ` : ''}${property.other_room || ''}`,
				fullPath: context.route.fullPath,
				image: property.mainImage,
				title: property.property_title
			})
		}
	},

	data:() => ({
		snackbar: false,
		snackbarText: '',
		agent: undefined,
		agentFloat: false,
		agentPanelWidth: null,
		bannerStyle: null,
		downPayment: 10,
		duration: 30,
		href: null,
		interestRate: 6.64,
		loading: true,
		max: 0,
		message: '',
		price: 0,
		property: undefined,
		coordinateValid: false,
		trace: null,
		focusMap: false,
		mapShare: false,
		mapShareX: 0,
		mapShareY: 0,
		imageSelected: null,
		imageScrolling: false,

		descriptionExpanded: false,

		contactMe: {
			success: false,
			loading: false,
			valid: true,
			name: '',
			phone: '',
			line: '',
			email: '',
			time: 'ทุกช่วงเวลา',
			tracking_comment: ''
		},

		submitLoading: false,

		alertError: false,
		alertText: '',
		overlay: false,
		overlayCallback: null,

		contactForm: false,
		customerPhone: null,
		customerName: null,
		text: null,
		additionalDetail: null,
	}),

	computed: {
		...mapGetters({
			isMobile: 'isMobile',
			head: 'page/head',
			getLocation: 'getLocation',
			getProperty: 'property/getProperty',
			isFavorite: 'property/isFavorite'
		}),

		refer () {
			if (this.agent && this.agent.generate_refer) {
				return JSON.parse(this.agent.generate_refer)
			}

			return null
		},

		isPresentationMode () {
			return this.$route.path.indexOf('/property-presentation') === 0
		},

		propLocationString () {
			if (!this.property) {
				return ''
			}

			if (this.property.lat && this.property.lng) {
				return `${this.property.lat},${this.property.lng}`
			} else if (this.property.coordinates) {
				return this.property.coordinates.replace(' ', '')
			}

			return ''
		}
	},

	watch: {
		agentFloat (val) {
			if (val) {
				this.agentPanelWidth = this.$refs.agentPanel.clientWidth - 24
			} else {
				this.agentPanelWidth = null
			}
			this.contactMe.menu = false
		},

		property (val) {
			if (val) {
				this.$nextTick(() => {
					const slider = document.getElementById('carousel')
					let pos = { top: 0, left: 0, x: 0, y: 0 }
					const mouseDownHandler = (e) => {
						slider.style.cursor = 'grabbing'
						slider.style.userSelect = 'none'
						slider.style.transform = 'scale(1)'

						pos = {
							left: slider.scrollLeft,
							// top: slider.scrollTop,
							x: e.clientX,
							// y: e.clientY,
						};

						document.addEventListener('mousemove', mouseMoveHandler)
						document.addEventListener('mouseup', mouseUpHandler)
					};

					const mouseMoveHandler = (e) => {
						this.imageScrolling = true // prevent click

						// How far the mouse has been moved
						const dx = e.clientX - pos.x
						// const dy = e.clientY - pos.y

						// Scroll the element
						// slider.scrollTop = pos.top - dy
						slider.scrollLeft = pos.left - dx
					};

					const mouseUpHandler = () => {
						setTimeout(() => {
							this.imageScrolling = false
						}, 10)

						slider.style.cursor = 'grab'
						slider.style.removeProperty('user-select')

						document.removeEventListener('mousemove', mouseMoveHandler)
						document.removeEventListener('mouseup', mouseUpHandler)
					};

					// Attach the handler
					slider.removeEventListener('mousedown', mouseDownHandler)
					slider.addEventListener('mousedown', mouseDownHandler)
				})
			}
		}
	},

	beforeRouteLeave (to, from, next) {
		if (process.client) {
			// Leave fullscreen mode (map)
			let cls = document.getElementsByTagName('html')[0].className
			document.getElementsByTagName('html')[0].className = cls.replace(
				' fullscreen',
				''
			)
			// gallery
			this.openGallery(-1)
			next()
		} else {
			next()
		}
	},

	created() {
		this.loading = true

		if (process.client) {
			window.scrollTo(0, 0)
		}
	},

	mounted() {
		this.property = this.getProperty(this.$route.params.id)

		if (!this.property) {
			this.loading = false

			return
		}

		if (['LAND', 'FACTORY', 'APARTMENT', 'OTHERS'].includes(this.property.category_en || null)) {
			this.downPayment = 30
			this.interestRate = 11.56
		}

		let coordinates = (this.property.coordinates || '').trim()
		this.coordinateValid = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/.test(coordinates)
		this.price = this.property.sale_price

		this.loading = false
		if (this.property) {
			if (!this.isPresentationMode) {
				this.getAgent(this.property.agent_id).then((res) => {
					this.agent = res
				}).catch((e) => {
					console.log(e)
				})
			}

			if (this.coordinateValid) {
				if (this.$route.query.focus === 'map') {
					this.focusMap = true
				}
			}
		}
	},

	methods: {
		...mapActions({
			getAgent: 'agent/getAgent',
			// setProperty: 'property/setProperty',
			addOrRemoveFavorite: 'property/addOrRemoveFavorite',
			customerInquiry: 'property/customerInquiry',
			pageInitial: 'page/initial'
		}),

		onScroll (e) {
			if (this.isMobile) {
				return
			}

			if (e.target.scrollingElement.scrollTop > 540) {
				this.agentFloat = true
			} else {
				this.agentFloat = false
			}
		},

		openGallery (index) {
			// this.$refs.gallery.children[0].children[index].click()
			if (this.imageScrolling) {
				return
			}

			if (index === -1) {
				this.imageSelected = index
			} else {
				this.imageSelected = -2
				this.$nextTick(() => {
					this.imageSelected = index
				})
			}
		},

		submitContactMe () {
			if (!this.contactMe.success && this.$refs.contactMeForm.validate()) {
				// if (this.contactMe.from || this.contactMe.to) {
				// 	this.contactMe.tracking_comment = 'ช่วงเวลาติดต่อ: ' + (this.contactMe.from || 'ไม่กำหนด') + ' - ' + (this.contactMe.to || 'ไม่กำหนด')
				// }
				//if (this.contactMe.from_HH || this.contactMe.from_MM || this.contactMe.to_HH || this.contactMe.to_MM) {
				//	this.contactMe.tracking_comment = 'ช่วงเวลาติดต่อ: ' + (this.contactMe.from_HH || '--') + ':' + (this.contactMe.from_MM || '--') + ' - ' + (this.contactMe.to_HH || '--') + ':' + (this.contactMe.to_MM || '--')
				//}
				this.contactMe.tracking_comment = 'ช่วงเวลาติดต่อ: ' + this.contactMe.time

				this.contactMe.loading = true
				this.contactMe.property_id = this.property.id
				this.customerInquiry(this.contactMe).then((res) => {
					console.log(res)
					if (res.error) {
						return
					}
					this.contactMe.success = true
					setTimeout(() => {
						this.$nextTick(() => {
							this.contactMe = {
								success: false,
								loading: false,
								valid: true,
								name: '',
								phone: '',
								line: '',
								email: '',
								time: 'ทุกช่วงเวลา',
								tracking_comment: ''
							}
							this.$refs.contactMeForm.resetValidation()
						})
					}, 5000)

					setTimeout(() => {
						this.contactMe.menu = false
					}, 6000)
				}).finally(() => {
					this.contactMe.loading = false
				})
			}
		},

		presentationUrlCopy (ref, getParams) {
			console.log(ref, getParams)
			ref.className = ''
			// ref.value = window.location.origin + this.$route.fullPath + (getParams ? `?${getParams}` : '')
			ref.value = `https://url.tb.co.th/${this.isPresentationMode ? 'presentation' : 'p'}/${this.property.id}`

			this.copyText(ref)
		},

		copyText (ref) {
			const val = ref.value
			ref.className = ''
			ref.focus()
			ref.select()

			try {
				document.execCommand('copy')
				this.snackbarText = 'คัดลอกแล้ว'
			} catch (err) {
				console.log('Oops, unable to copy')
				this.snackbarText = 'ไม่สามารถคัดลอกได้'
			} finally {
				ref.blur()
				ref.value = val
				ref.className = 'd-none'

				this.snackbar = true
			}
		},

		propertyDirectionText (key) {
			let item = configSearch.propertyDirection.find(i => i.value === key)
			if (item) {
				return item.text
			}

			return ''
		},

		mapShareShow (event) {
			event.preventDefault()
			let rect = this.$refs.mapShareBtn.$el.getBoundingClientRect()
			this.mapShare = false
			this.mapShareX = rect.right
			this.mapShareY = rect.bottom
			this.$nextTick(() => {
				this.mapShare = true
			})
		},

		imageURL (name) {
			if (name.indexOf('https://') === 0) {
				return name
			} else if (this.property.id > 24788) {
				// return `https://www.googleapis.com/download/storage/v1/b/tb-co-th-263110.appspot.com/o/${name}?&alt=media`
				return `https://storage.googleapis.com/tb-co-th-263110.appspot.com/${name}?alt=media`
			} else {
				return `https://api.tb.co.th/api/getImageProperty?id=${this.property.id}&path=${name}`
			}
		},

		phoneFormat () {
			this.customerPhone = this.customerPhone.replaceAll(/\D/g, '')
		},

		submitQuery () {
			if (!this.$refs.contactForm.validate()) {
				return
			}

			this.submitLoading = true
			this.$fireFunc.httpsCallable('customer-contact')({
				customer_name: this.customerName,
				customer_phone: this.customerPhone,
				additional_detail: this.additionalDetail,
				source: 'contact-agent',
				agent_id: this.agent.id,
				property_id: this.property.id
			}).then(({data}) => {
				if (data.error) {
					this.alert({
						error: true,
						text: 'ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้งภายหลัง หรือติดต่อผู้ดูแลระบบ',
						callback: () => {
							this.overlay = false
						}
					})
				} else {
					this.alert({
						error: false,
						text: 'เราได้รับคำขอของคุณแล้ว เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ ขอขอบคุณที่ท่านให้ความสนใจในบริการของเรา เราจะติดต่อกลับท่านโดยเร็วที่สุด',
						callback: () => {
							this.overlay = false
						}
					})
				}
			}).catch(() => {
				this.alert({
					error: true,
					text: 'ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้งภายหลัง หรือติดต่อผู้ดูแลระบบ',
					callback: () => {
						this.overlay = false
					}
				})
			}).finally(() => {
				this.$refs.contactForm.reset()
				this.submitLoading = false
			})
		},

		alert (config) {
			this.alertError = config.error
			this.alertText = config.text
			this.overlayCallback = config.callback || (() => {})
			this.overlay = true
		},
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>

.contact-form ::v-deep {
	.v-text-field__details {
		margin-bottom: 0;
	}
}
.contactBtn {
	position: absolute;
	right: 0;
	top: -5px;

	button {
		background: #c20000;
		color: #fff;
		height: 26px;
		font-size: 0.9em;
		padding: 0 25px;
	}
	a {
		text-decoration: none;
		margin-right: 5px;
	}
	i {
		color: #c20000;
		font-size: 1.7em;
	}
}
.mini-detail {
	& > div {
		display: flex;
		align-items: center;
		margin-right: 16px;

		img {
			width: 1rem;
			margin-right: 5px;
		}
	}
}
.property-price {
	position: relative;
	font-weight: bold;

	&:before {
		content: ' ';
		background-color: #eee;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 50vw;
	}
	span {
		position: relative;
		font-size: 1.2rem;
		z-index: 1;
	}
	div {
		position: relative;
		font-size: 2rem;
		line-height: 2rem;
		z-index: 1;
	}
}
.dividerGray:before {
	background: #e6e6e6;
	content: "";
	display: block;
	position: absolute;
	top: 0px;
	right: 0;
	left: 0;
	height: 1px;
}
.content-box {
	border-top: solid 4px #c20000;
	background-color: #eee;
}
.property-spec {
	span {
		position: relative;
		font-size: 1rem;
		color: #919191;

		&.dot::before {
			content: ' ';
			position: absolute;
			left: 10px;
			top: -5px;
			font-size: 1.5rem;
			display: list-item;
			color: #000;
		}
	}
	div {
		font-size: 1.1rem;
		font-weight: bold;
	}
}
.expandable {
	position: relative;
	max-height: 180px;
	overflow: hidden;

	&.expanded {
		max-height: unset;

		.expand-btn {
			display: none !important;
		}
	}
	.expand-btn {
		cursor: pointer;
		background: linear-gradient(to bottom,
			rgba(238, 238, 238, 0.2) 0%,
			rgba(238, 238, 238, 0.6) 15%,
			rgba(238, 238, 238, 0.9) 30%,
			rgba(238, 238, 238, 1) 100%
		);
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		font-size: 1rem;
		font-weight: bold;
	}
}

.fieldDisabled::v-deep {
  input { color: #000!important; }
}
.map {
	.iconSend {
		color: #c20000;
	}
}

.installment-config {
	font-weight: bold;
	font-size: 1.1rem;

	.full-price {
		font-size: 2rem;
		line-height: 2rem;
	}

	.down i {
		background: #c20000;
	}
	.amount i {
		background: #adadad;
	}
	i {
		border-radius: 50%;
		display: inline-block;
		height: 10px;
		margin-left: 10px;
		width: 10px;
	}
	::v-deep {
		.v-input__control {
			border-radius: 0;
		}
		.v-slider__track-container {
			height: 5px !important;
		}
		.v-slider__thumb {
			width: 18px;
			height: 18px;

			&::before {
				left: -9px;
				top: -9px;
			}
		}
	}

}
.progress {
	position: relative;
	.installment {
		position: absolute;
		top: 90px;
    left: 0;
    right: 0;

		div {
			font-size: 2rem;
			line-height: 2rem;
			font-weight: bold;
			color: #c20000;
		}
	}
	span {
		border-radius: 50%;
		display: inline-block;
		height: 10px;
		margin-right: 10px;
		width: 10px;
	}
	.amount {
		font-size: 1em;
		font-weight: bold;
		span {
			background: #adadad;
		}
	}
	.down {
		font-size: 1em;
		font-weight: bold;
		span {
			background: #c20000;
		}
	}
	a .v-progress-circular__underlay {
		stroke: #adadad;
	}
	&::v-deep .v-progress-circular__underlay {
		stroke: #adadad !important;
		stroke-width: 10;
	}
}
.agent-widget::v-deep {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 50px;
	z-index: 5;

	&.mobile {
		bottom: 0;

		.v-expansion-panel {
			border-radius: 0;
		}
		.v-expansion-panel-content__wrap {
			padding: 0;
		}
		.agent-contact {
			border-radius: 0 !important;
		}
	}
	.agent {
		box-shadow: 0px 0px 20px 5px rgba(0, 0, 0, 0.25);
		border-radius: 5px;
		background-color: #fff;
	}
	.agent-contact {
		background-color: #3a3a3a;
		border-radius: 5px 0 0 5px;

		a {
			color: #fff;
			text-decoration: none;
		}
		.image-agent {
			& > div {
				border-radius: 50%;
				background-color: transparent!important;

				.v-image__image {
					border-radius: 50%;
					overflow: hidden;
				}
			}
		}
		.call {
			background: #c20000;
			i {
				color: #fff;
			}
		}
	}
	.divider-v, .divider-h {
		position: relative;

		&::before {
			content: ' ';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: #3a3a3a;
			clip-path: polygon(-1px 0, 0 0, 100% 100%, -1px 100%);
		}
		&.divider-h::before {
			clip-path: polygon(-1px 0, 100% 0, 100% 100%);
		}

		div {
			position: relative;
			color: #fff;
			background-color: #a12028;
			border-radius: 50%;
			padding: 20px;
		}
	}
	.callback {
		border-radius: 0 5px 5px 0;
	}
}
.tabMenu {
	button {
		background: #b8b8b8;
		border-radius: 0;
		color: #c20000;
		font-size: 0.9em;
		padding: 5px 25px;
	}
	i {
		color: #c20000;
		margin-right: 10px;
	}
	a:hover, .active {
		background: #c20000 !important;
		color: #fff;
		i {
			color: #fff;
		}
	}
	.v-btn::before {
		opacity: 0 !important;
	}
}
/*.carousel::v-deep {
  .tns-nav, .tns-liveregion { display: none; }
}*/
.totalPointer { background: #c20000; border-radius: 50%; font-size: 0.8em; display: inline-block; height: 32px; text-align: center; padding-top: 7px; vertical-align: middle; width: 32px; }

#breadcrumb-detail::v-deep { display: block; height: 30px; margin-top: -25px; overflow-x: auto; padding: 0; white-space: nowrap; -webkit-overflow-scrolling: touch;
	> li { display: inline-block !important;
		> a { color: #333; }
	}
}
#carousel {
	cursor: grab;
	height: 300px;
	width: 100%;
	white-space: nowrap;
	overflow-x: auto;
	overflow-y: hidden;
	-webkit-overflow-scrolling: touch;

	&::-webkit-scrollbar {
		height: 3px;
		margin-top: -15px;
	}
	&::-webkit-scrollbar-track {
		background: #fff;
	}
	&::-webkit-scrollbar-thumb {
		background: #888;
	}
	&::-webkit-scrollbar-thumb:hover {
		background: #555;
	}
	img { height: 100%; display: inline-block; }
}

#gallery {
	// display: none;
	position: absolute;
	top: -100%;
}
#copy-img-btn {
	position: fixed;
	z-index: 2147483647 !important;
	top: 15px;
	left: 15px;
}

.v-expansion-panels {
	z-index: inherit;
}

.no-property {
	height: calc(100vh - 343px);
}
</style>
